import { Link } from '@remix-run/react'
import { cva, type VariantProps } from 'class-variance-authority'
import { forwardRef } from 'react'
import { cn, getLogoImgSrc } from '#app/utils/misc.tsx'
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar'

const logoAvatarImageVariants = cva('h-8 w-8 rounded-lg', {
	variants: {
		size: {
			sm: 'h-8 w-8',
			md: 'h-14 w-14',
			lg: 'h-24 w-24',
			xl: 'h-52 w-52',
		},
	},
	defaultVariants: {
		size: 'md',
	},
})

export const LogoAvatarImage = forwardRef<
	HTMLDivElement,
	VariantProps<typeof logoAvatarImageVariants> & {
		className?: string
	}
>(({ size = 'md', className }, ref) => {
	return (
		<Avatar
			ref={ref}
			className={cn(logoAvatarImageVariants({ size }), className)}
		>
			<AvatarImage
				src={getLogoImgSrc()}
				alt="Choros"
				className="-ml-1 mt-2 object-cover"
			/>
			<AvatarFallback className="rounded-lg">C</AvatarFallback>
		</Avatar>
	)
})

export const Logo = forwardRef<
	HTMLDivElement,
	VariantProps<typeof logoAvatarImageVariants> & {
		className?: string
	}
>(({ size = 'md', className }, ref) => {
	return (
		<LogoAvatarImage
			size={size}
			className={cn('rounded-none', className)}
			ref={ref}
		/>
	)
})

export const LogoHome = forwardRef<
	HTMLAnchorElement,
	VariantProps<typeof logoAvatarImageVariants> & {
		className?: string
	}
>(({ size = 'md', className }, ref) => {
	return (
		<Link
			to="/"
			ref={ref}
			className={cn('group grid leading-snug', className)}
			prefetch="intent"
			// viewTransition
		>
			<LogoAvatarImage size={size} className="rounded-none" />
		</Link>
	)
})
